const links = {
    ru: {
        api: 'https://developer.131.ru'
    },
    en: {
        api: 'https://developer.131.ru/en'
    }
};

export default links;
